import service from '@/plugins/service'

const base = '/system/dict'

export const getDictList = (current, pageSize) => {
  return service({
    url: `${base}`,
    method: 'GET',
    params: {
      current,
      pageSize
    }
  })
}

export const searchDictList = (current, pageSize, data) => {
  return service({
    url: `${base}/query`,
    method: 'POST',
    params: {
      current,
      pageSize
    },
    data
  })
}

export const addDict = data => {
  return service({
    url: `${base}`,
    method: 'POST',
    data
  })
}

export const getDict = (lang, code) => {
  return service({
    url: `${base}`,
    method: 'GET',
    params: {
      lang,
      code
    }
  })
}

export const updateDict = data => {
  return service({
    url: `${base}`,
    method: 'PUT',
    data
  })
}

export const removeDict = id => {
  return service({
    url: `${base}`,
    method: 'DELETE',
    params: {
      id
    }
  })
}
